export function getCompGeometry(layoutWidth, layoutHeight, comp) {
  layoutWidth = Number(layoutWidth);
  layoutHeight = Number(layoutHeight);
  const width = Number(comp?.width);
  const height = Number(comp?.height);
  const side = comp?.side;

  if (!Number.isFinite(layoutWidth) || !Number.isFinite(layoutHeight) || layoutWidth <= 0 || layoutHeight <= 0
    || !Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0
    || !['left', 'below'].includes(side)) {
    return null;
  }

  if (side === 'left') {
    return {
      width: layoutWidth + width,
      height: Math.max(layoutHeight, height),
      layout: { left: width, top: 0, width: layoutWidth, height: layoutHeight },
      comp: { left: 0, top: 0, width, height },
      worldComp: { left: -width, top: 0, width, height }
    };
  }

  return {
    width: Math.max(layoutWidth, width),
    height: layoutHeight + height,
    layout: { left: 0, top: 0, width: layoutWidth, height: layoutHeight },
    comp: { left: 0, top: layoutHeight, width, height },
    worldComp: { left: 0, top: layoutHeight, width, height }
  };
}
